import { render, staticRenderFns } from "./RosterProve.vue?vue&type=template&id=6c07e1e8"
import script from "./RosterProve.vue?vue&type=script&lang=js"
export * from "./RosterProve.vue?vue&type=script&lang=js"
import style0 from "./RosterProve.vue?vue&type=style&index=0&id=6c07e1e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports